import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import TextField from "@mui/material/TextField";
import { getNestedError } from "utils";

export const MaskInput = ({
  customDesign = true,
  label,
  labelHeader,
  placeholder,
  control,
  rules,
  name,
  className,
  disabled,
  onFocus,
  onBlur,
  mask,
}) => {
  let inputRef;
  inputRef = useRef(null);

  return (
    <div
      className={`input-main-wrapper ${
        customDesign ? "input-custom-wrapper" : ""
      } ${className ? className : ""}`}
    >
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({
          field: { onChange, value, name },
          formState: { errors },
        }) => {
          const error = getNestedError(errors, name);
          const hasError = !!error?.type;

          if (hasError && inputRef.current) {
            // inputRef.current.focus();
            inputRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }

          return (
            <>
              {labelHeader && (
                <p
                  className={`input-main-label-header ${
                    error?.message ? "errorLabel" : ""
                  }`}
                >
                  {labelHeader}
                  {rules?.required && (
                    <span className="input-main-label-header-required">*</span>
                  )}
                </p>
              )}
              <InputMask
                mask={mask ? mask : "(999) 999-9999"}
                value={value}
                onChange={onChange}
                disabled={disabled}
                onFocus={onFocus}
                onBlur={onBlur}
              >
                {() => (
                  <TextField
                    error={!!error?.message}
                    name={name}
                    autoComplete="off"
                    placeholder={placeholder}
                    label={label}
                    disabled={disabled}
                  />
                )}
              </InputMask>

              <p className="error-message">{error?.message}</p>
            </>
          );
        }}
      />
    </div>
  );
};
